module.exports = __webpack_public_path__ + "static/img/battery.225587d0.png";